<template>
  <div>
    <projects-coworkers
      :mode="projectCoworkersTableMode"
      :project-id="digitalizationProjectId"
    >
    </projects-coworkers>
  </div>
</template>

<script src="./DigitalizationProjectCoworkers.script.ts" lang="ts"></script>
<style
  src="./DigitalizationProjectCoworkers.style.scss"
  lang="scss"
  scoped
></style>
